import { Component } from '@angular/core';

@Component({
  selector: 'app-main-layout-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent {}
